import axios from "axios";

export const getPublicIPAddress = () => {
  return new Promise((resolve, reject) => {
    axios.get('https://api.ipify.org?format=json')
      .then((response) => {
        resolve(response.data.ip);
      })
      .catch((error) => {
        reject(error);
      });
  });
};


export const getTimezoneOffset = () => {
  const offsetMinutes = new Date().getTimezoneOffset();
  const offsetHours = Math.floor(Math.abs(offsetMinutes) / 60);
  const offsetMinutesRemainder = Math.abs(offsetMinutes) % 60;
  const sign = offsetMinutes < 0 ? '+' : '-';
  return `${sign}${offsetHours
    .toString()
    .padStart(2, '0')}:${offsetMinutesRemainder.toString().padStart(2, '0')}`;
};